export default "__VITE_ASSET__CzI$JuoJ__"